<template>
	<header-block title="Your Personal News" bgcolor="white"></header-block>
	
	<transition v-if="working">
		<p v-html="log.replaceAll('\n', '<br/>')"></p>
	</transition>
	<transition v-if="working">
		<p class="pulsate">{{ message }}</p>
	</transition>
	<transition v-if="news">
		<p v-html="news.replaceAll('\n', '<br/>')"></p>
	</transition>
	<div style="height: 30px;"></div>
	
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import Helpers from '../mixins/Helpers';

export default {
	mixins: [Services, Helpers],
	components: { HeaderBlock },
	data() {
		return {
			news:null,
			working: true,
			loadingMessages: [
				"Reading the latest headlines 🧐 ...",
				'Gathering the latest financial news 📰 ☕...',
				"Looking for updates on your finances 🫣 ...",
				"Checking your insurance policies 💪 ...",
				"Looking at your pensions 🤩 ...",
				"Checking your documents 📑 ...",
				"Gathering the latest news on your investments 🤓 ...",
				"Checking your mortgages 🏠 ...",
				"Checking your bank accounts for the latest transactions 🤑 ...",
				"Checking your spending this week 💸 ...",
				"Studying your spending habits 🤯 ...",
				"Looking for the latest discounts on your shopping 🥳 ...",
				'Creating your personal news feed, this may take a few seconds 🔨 ...',
			],
			loadingIndex: 1,
			message: "Reading the latest headlines 🧐 ...",
			log: ""
		}
	},
	methods: {
		onLoad: async function() {
			this.interval = setInterval(() => {
				if (!this.working) {
					clearInterval(this.interval);
				} else {
					this.message = this.loadingMessages[this.loadingIndex];
					if (this.loadingIndex > 0 ) { 
						var toAdd = this.loadingMessages[this.loadingIndex-1].replace('...', '') + "\n";
						if (!this.log.includes(toAdd)) {
							this.log += toAdd;
						}
					}
					this.loadingIndex = (this.loadingIndex + 1) % this.loadingMessages.length;
				}
			}, 4000);
			this._getPersonalNews((res, stillWorking) => {
				if (!stillWorking) { 
					this.working = false; 
					this.news = res;
					clearInterval(this.interval);
				}
			})
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.pulsate {
	animation: pulsate 1.5s infinite;
}

@keyframes pulsate {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(0.98);
		opacity: 0.7;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}

</style>
